var _circle, _rect, _rect2, _circle2, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSteps = function SvgSteps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 31,
    viewBox: "0 0 708 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 16,
    r: 15,
    fill: "url(#paint0_linear_6772_69032)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 15,
    width: 643,
    height: 2,
    fill: "#ECC8BC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 17,
    width: 311,
    height: 2.00003,
    transform: "rotate(180 340 17)",
    fill: "url(#paint1_linear_6772_69032)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 15,
    r: 14,
    fill: "#FFF0F0",
    stroke: "url(#paint2_linear_6772_69032)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.999,
    cy: 15.0002,
    r: 5.29412,
    fill: "url(#paint3_linear_6772_69032)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 693,
    cy: 15,
    r: 14,
    fill: "#FFF0F0",
    stroke: "#ECC8BC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7992 19.8803L7.59922 15.7012L6.19922 17.0942L11.7992 22.6663L23.7992 10.726L22.3992 9.33301L11.7992 19.8803Z",
    fill: "#FBFBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6772_69032",
    x1: -5.43932e-8,
    y1: 14.6028,
    x2: 41.6683,
    y2: 15.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6772_69032",
    x1: 340,
    y1: 17.9069,
    x2: 457.529,
    y2: 210.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6772_69032",
    x1: 339,
    y1: 13.6028,
    x2: 380.668,
    y2: 14.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6772_69032",
    x1: 348.705,
    y1: 14.507,
    x2: 363.412,
    y2: 14.6618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
};
export { SvgSteps as ReactComponent };
export default "data:image/svg+xml;base64,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";